<template>
  <div class="page-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <div class="filter-box">
          <div class="filter">
            <div class="filter-item">
              <div class="label">所属公司/部门</div>
              <el-cascader
                v-model="filter.status"
                :options="orgStructList2"
                class="select"
                popper-class="struct-select"
                style="width: 240px;"
                size="small"
                :props="{
                  children: 'list',
                  value: 'id',
                  label: 'name',
                  // multiple: true,
                  checkStrictly: true,
                }"
              ></el-cascader>
            </div>
            <!-- <div class="filter-item">
            <div class="label">所属部门</div>
            <el-select
              v-model="filter.status"
              size="small"
              class="select"
              placeholder="请选择"
            >
              <el-option
                :label="item.labelName"
                :value="item.value"
                v-for="item in companyList"
                :key="item.value"
              >
              </el-option>
            </el-select>
          </div> -->
            <div class="btn-box">
              <button class="search" @click="search">筛选</button>
              <button class="reset" @click="reset">重置</button>
            </div>
          </div>
        </div>
        <div style="display: flex;justify-content: flex-start;width: 100%;margin-top: 12px;">
          <div class="btn" style="margin: 0;" @click="addUserModal('add')">
            + 添加员工
          </div>
          <!-- <div class="btn import-btn" @click="getQrcodeModal">
            绑定微信二维码
          </div> -->
        </div>
        <!-- 表格 -->
        <el-table
          :data="userList"
          class="order-table table no-border-table"
          ref="orderTable"
          border
          :header-cell-style="{
            color: '#333',
            background: '#f6f6f6',
            borderBottom: '1px solid #E8E8E8',
            height: '54px',
          }"
          :row-style="{
            height: '54px',
          }"
        >
          <el-table-column
            prop="uid"
            align="center"
            label="ID"
          ></el-table-column>
          <el-table-column
            prop="username"
            align="center"
            label="姓名"
          ></el-table-column>
          <el-table-column
            prop="phone"
            align="center"
            label="电话"
          ></el-table-column>
          <el-table-column prop="phone" align="center" label="公司/部门/职务">
            <div slot-scope="scope">
              {{ scope.row.positionList | orgStructFormat }}
            </div>
          </el-table-column>
          <el-table-column
            prop="description"
            align="center"
            label="备注"
          ></el-table-column>
          <!-- <el-table-column prop="isBindWx" align="center" label="是否绑定微信">
            <div slot-scope="scope">
              {{ scope.row.isBindWx ? "是" : "否" }}
            </div>
          </el-table-column> -->
          <!-- <el-table-column prop="source" align="center" label="销售二维码">
            <div slot-scope="scope" class="table-btn-box">
              <button
                size="mini"
                class="table-btn"
                @click="getQrcodeModal2(scope.row.uid)"
              >
                查看二维码
              </button>
            </div>
          </el-table-column> -->
          <el-table-column
            label="操作"
            fixed="right"
            align="center"
            width="250"
          >
            <div slot-scope="scope" class="table-btn-box">
              <button
                size="mini"
                class="table-btn"
                @click="updateStatus(scope.row.uid, 1)"
                v-if="scope.row.status === 0"
              >
                冻结
              </button>
              <button
                size="mini"
                class="table-btn"
                style="color: #E67E4E;"
                @click="updateStatus(scope.row.uid, 2)"
                v-if="scope.row.status === 1"
              >
                启用
              </button>
              <button
                size="mini"
                class="table-btn"
                @click="addUserModal('edit', scope.row)"
              >
                修改
              </button>
              <!-- <button
                size="mini"
                class="table-btn"
                @click="updateUserModal(scope.row)"
              >
                过渡
              </button> -->
              <button
                size="mini"
                class="table-btn"
                @click="handleQuanxian(scope.row.uid)"
              >
                查看权限
              </button>
            </div>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页按钮 -->
      <div class="footer" :key="paginationKey">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          background
          layout="total, prev, pager, next, jumper"
          :page-size="size"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog :visible.sync="visible" class="dialog" width="600px" top="10vh">
      <div slot="title" class="dialog-title">
        {{ type === "edit" ? "编辑" : "添加" }}员工
      </div>
      <el-form
        ref="form"
        :model="form"
        class="user-form"
        label-width="auto"
        label-position="top"
      >
        <el-form-item label="所属组织架构" prop="assignTime" class="form-item">
          <!-- <el-select
            v-model="form.source"
            placeholder="请选择"
            size="small"
            class="input"
            style="width: 536px"
          >
            <el-option
              v-for="item in source"
              :key="item.value"
              :label="item.labelName"
              :value="item.value"
            >
            </el-option>
          </el-select> -->
          <el-cascader
            v-model="positionList"
            :options="orgStructList"
            class="select"
            popper-class="struct-select"
            size="small"
            style="width: 536px;"
            :props="{
              children: 'list',
              value: 'id',
              label: 'name',
              multiple: true,
              //   checkStrictly: true,
            }"
          ></el-cascader>
        </el-form-item>
        <!-- <el-form-item label="所属部门" prop="assignTime" class="form-item">
          <el-select
            v-model="form.source"
            placeholder="请选择"
            size="small"
            class="input"
            style="width: 536px"
          >
            <el-option
              v-for="item in source"
              :key="item.value"
              :label="item.labelName"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="选择职务" prop="assignTime" class="form-item">
          <el-select
            v-model="form.source"
            placeholder="请选择"
            size="small"
            class="input"
            style="width: 536px"
          >
            <el-option
              v-for="item in source"
              :key="item.value"
              :label="item.labelName"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="员工姓名*" prop="username" class="form-item">
          <el-input
            size="small"
            placeholder="请输入"
            style="width: 240px"
            v-model="form.username"
          ></el-input>
        </el-form-item>
        <el-form-item label="员工电话*" prop="phone" class="form-item">
          <el-input
            size="small"
            placeholder="请输入"
            style="width: 240px"
            v-model="form.phone"
          ></el-input>
        </el-form-item>
        <el-form-item label="密码*" prop="password" class="form-item">
          <el-input
            size="small"
            placeholder="请输入"
            style="width: 536px"
            v-model="form.password"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="description" class="form-item">
          <el-input
            type="textarea"
            placeholder="请输入"
            v-model="form.description"
            style="width: 536px;margin-top: 6px;"
            :autosize="{ minRows: 3 }"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel-btn btn" @click="visible = false"
          >取 消</el-button
        >
        <el-button class="confirm-btn btn" @click="handleAddUser"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog :visible.sync="visible2" class="dialog" width="600px" top="10vh">
      <div slot="title" class="dialog-title">查看权限组</div>
      <div class="group-list">
        <el-checkbox
          v-model="item.selected"
          v-for="item in groupList"
          class="checkbox"
          :key="item.id"
          >{{ item.name }}</el-checkbox
        >
      </div>
    </el-dialog>

    <el-dialog :visible.sync="visible3" class="dialog" width="480px" top="25vh">
      <div slot="title" class="dialog-title">
        过渡
      </div>
      <el-form
        ref="form"
        :model="form2"
        class="category-form"
        label-position="top"
        label-width="auto"
        style="padding: 20px 0"
      >
        <el-form-item label="选择目标员工" prop="link" class="form-item">
          <el-cascader
            v-model="form2.newSuperior"
            :options="orgStructList3"
            class="select"
            popper-class="struct-select"
            size="small"
            v-if="visible3"
            style="width: 100%;"
            :props="{
              children: 'list',
              value: 'id',
              label: 'name',
            }"
          ></el-cascader>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel-btn btn" @click="visible3 = false"
          >取 消</el-button
        >
        <el-button class="confirm-btn btn" @click="updateUser">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="微信二维码"
      :visible.sync="wxDialog"
      width="320px"
      custom-class="wx-dialog"
    >
      <div slot="title" class="wx-dialog-title">微信二维码</div>
      <div class="wx-box">
        <img :src="qrcode" alt="" />
        <div>
          若账号需要接收用户跟进时间提醒需扫这个码绑定微信，并关注公众号
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="微信二维码"
      :visible.sync="wxDialog2"
      width="320px"
      custom-class="wx-dialog"
    >
      <div slot="title" class="wx-dialog-title">销售二维码</div>
      <div class="wx-box">
        <img :src="qrcode2" alt="" />
        <!-- <div>
          若账号需要接收用户跟进时间提醒需扫这个码绑定微信，并关注公众号
        </div> -->
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
import JSEncrypt from 'jsencrypt';
import pubKey from '@/assets/js/pubKey.js';
import { role, roleMap } from '@/config.js';
import myUtils from '../../components/common/whatever2excel';
import dayjs from 'dayjs';
export default {
  components: {
    Header
  },
  name: 'user-manage',
  data() {
    return {
      currentPage: 1, // 当前页码
      size: 20, // 每页条数
      total: 0, // 总页数
      loading: 0, // 加载中
      title: {
        // 页面标题
        firstTitile: '组织架构',
        secondTitle: '员工列表'
      },

      dealMap: {
        1: '未成交',
        2: '已成交'
      },
      matriculateMap: {
        1: '未录取',
        2: '已录取'
      },

      filter: {
        // 过滤条件
        companyId: null,
        departmentId: null,
        username: '',
        phone: '',
        status: []
      },
      companyList: [],
      userList: [], // 客户列表
      date: [],
      uid: null,
      form: {
        positionList: [],
        username: '',
        phone: '',
        password: '',
        description: ''
      },
      form2: {
        newSuperior: []
      },
      visible: false,
      paginationKey: +new Date(),
      company: [],
      customerStatus: [],
      level: [],
      source: [],
      orgStructList: [],
      orgStructList2: [],
      orgStructList3: [],
      positionList: [],
      type: '',
      visible2: false,
      visible3: false,
      info: {},
      qrcode: '',
      qrcode2: '',
      wxDialog: false,
      wxDialog2: false,
      groupList: [],
      uid: null
    };
  },
  filters: {
    // 时间格式化
    dateFormat(date) {
      if (!date) return '请选择时间';
      let day = dayjs(date);
      return day.format('YYYY-MM-DD HH:mm:ss');
    },
    orgStructFormat(val){
        if(!val || !val.length) return;
        let str = '';
        val.forEach(item => {
            str += `${item.companyName}/${item.departmentName}/${item.positionName}; `
        });
        return str;
    }
  },
  // beforeRouteEnter(to, from, next) {
  //   if (from.name !== 'userDetail' && from.name !== 'popularize') {
  //     sessionStorage.setItem('userManage', '');
  //   }
  //   next();
  // },
  mounted() {
    // let data = sessionStorage.getItem('userManage')
    //   ? JSON.parse(sessionStorage.getItem('userManage'))
    //   : '';
    // if (data) {
    //   this.filter = {
    //     ...this.filter,
    //     ...data.filter
    //   };
    //   this.date = data.date;
    //   this.currentPage = data.currentPage;
    //   this.paginationKey = +new Date();
    //   // this.setSearchData();
    // }
    // 获取列表
    this.getUserList();
    // this.getDictionary();
    this.getOrgStructList();
    this.getOrgStructList2();
  },
  computed: {},
  methods: {
    // setSearchData() {
    //   let userManage = {
    //     currentPage: this.currentPage,
    //     filter: this.filter,
    //     date: this.date
    //   };
    //   sessionStorage.setItem('userManage', JSON.stringify(userManage));
    // },
    // 表格序号
    tableIndex(index) {
      return ++index;
    },
    // 切换页码
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getUserList();
    },
    // 获取客户列表
    getUserList() {
      this.filter.companyId = this.filter.status[0];
      this.filter.departmentId = this.filter.status[1];
      this.loading++;
      this.httpGet(this.$root.getMemberList, {
        page: this.currentPage,
        size: this.size,
        ...this.filter
      }).then(
        (res) => {
          this.loading--;
          this.userList = res.list;
          this.total = res.total;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    getOrgStructList(){
        this.loading++;
        this.httpGet(this.$root.getOrgStructList, {

        }).then(
            (res) => {
            this.loading--;
            this.orgStructList = res.list;
            this.orgStructList2 = res.list.map(item => {
                return {
                    ...item,
                    list: item.list.map(item2 => {
                        return {
                            ...item2,
                            list: null
                        }
                    })
                }
            })
            },
            (res) => {
            this.loading--;
            this.$message.error(res);
            }
        );
    },
    getOrgStructList2(){
        this.loading++;
        this.httpGet(this.$root.getOrgStructList, {
          showUsers: 1
        }).then(
            (res) => {
            this.loading--;
            this.orgStructList3 = res.list;
            },
            (res) => {
            this.loading--;
            this.$message.error(res);
            }
        );
    },
    getDictionary(){
      this.getDictionaryByName('company');
      this.getDictionaryByName('customerStatus');
      this.getDictionaryByName('level');
      this.getDictionaryByName('source');
    },
    getDictionaryByName(dataName){
      this.loading++;
      this.httpGet(this.$root.getDictionaryByName, {
        dataName
      }).then(
        (res) => {
          this.loading--;
          this[dataName] = res.list;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    async getQrcodeModal(){
      await this.getQrcode();
      this.wxDialog = true;

    },
    getQrcode(){
      this.loading++;
      return this.httpPost(this.$root.getQrcode, {
        page: 'pages/login/bind-wx'
      }).then(
        (res) => {
          this.loading--;
          this.qrcode = res.url;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    async getQrcodeModal2(uid){
      this.uid = uid;
      await this.getQrcode2();
      this.wxDialog2 = true;
    },
    getQrcode2(){
      this.loading++;
      return this.httpPost(this.$root.getUserQrcode, {
        page: 'pages/front/front',
        // scene: `1,${this.uid}`,
        uid: this.uid
      }).then(
        (res) => {
          this.loading--;
          this.qrcode2 = res.url;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    addUserModal(type, rowData = {}) {
        this.type = type;
      this.form = {
        positionList: [],
        username: '',
        phone: '',
        password: '',
        description: ''
      };
      this.positionList = [];
      if(type === 'edit'){
        this.form = {
            positionList: [],
            uid: rowData.uid,
            username: rowData.username,
            phone: rowData.phone,
            password: rowData.password,
            description: rowData.description,
        }
        this.positionList = rowData.positionList.map(item => {
            return [item.companyId, item.departmentId, item.positionId];
        });
      }
      this.$refs.form && this.$refs.form.clearValidate();
      this.visible = true;
    },
    // 身份授权
    handleAddUser() {
        this.loading++;
        // let time = (+new Date() + '').substr(0, 10);
	    let password = this.form.password ? this.rsa(`${this.form.password}`) : '';
        let form = {
            ...this.form,
            positionList: this.positionList.map(item => item[2]),
            password
        };
        let url = 'addMember';
        if(this.type === 'edit') url = 'updateMember';
        this.httpPost(this.$root[url], form).then(
        (res) => {
            this.loading--;
            this.visible = false;
            this.$message({
            message: '操作成功',
            type: 'success'
            });
            this.getUserList();
        },
        (res) => {
            this.loading--;
            this.$message.error(res);
        }
        );
    },
    // 客户详情
    toDetail(uid) {
      this.$router.push({
        name: 'userDetail',
        query: {
          uid
        }
      });
    },
    // 过滤
    search() {
      console.log(this.filter);
      this.currentPage = 1;
      this.getUserList();
    },
    // 重置过滤
    reset() {
      this.filter = {
        companyId: null,
        departmentId: null,
        username: '',
        phone: '',
        status: []
      };
      this.date = [];
      this.getUserList();
    },
    rsa(pass) {
        console.log('加密前', pass)
        var encryptor = new JSEncrypt() // 创建加密对象实例
        encryptor.setPublicKey(pubKey) //设置公钥
        return encryptor.encrypt(pass) || '加密失败'
    },
    handleQuanxian(uid){
      this.groupList = [];
      this.visible2 = true;
      this.loading++;
        this.httpGet(this.$root.getGroupListByUser, {
          uid
        }).then(
          (res) => {
            this.loading--;
            this.groupList = res.list;
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
    },
    updateStatus(uid, type){
      let str = '', url = '';
      if(type === 1){
        str = '冻结';
        url = 'freezeUser';
      } else {
        str = '恢复';
        url = 'unfreezeUser';
      };
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定要${str}吗？</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpPut(this.$root[url], {
          uid: uid
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getUserList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    updateUserModal(data){
      this.info = data;
      this.form2.newSuperior = [];
      this.visible3 = true;
    },
    updateUser(){
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定要修改客户关联销售吗？</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpPut(this.$root.bindingSuperior, {
          oldSuperior: this.info.uid,
          newSuperior: this.form2.newSuperior.length ? this.form2.newSuperior[3] : null
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.visible3 = false;
            this.loading--;
            this.getOrgStructList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    }
    // async order2excel() {
    //   this.loading++;
    //   let userList = [];
    //   let totalPage = null;
    //   let data = {
    //     page: this.currentPage,
    //     size: this.size,
    //     ...this.filter
    //   };
    //   await this.httpGet(this.$root.getUserList, data).then(
    //     (res) => {
    //       this.loading--;
    //       totalPage = Math.ceil(parseInt(res.total) / this.size);
    //     },
    //     () => {
    //       this.loading--;
    //     }
    //   );
    //   this.showProgressDialog = true;
    //   this.progress = 0;
    //   await this.getAllPages(totalPage, userList).then(
    //     () => {
    //       this.showProgressDialog = false;
    //       this.jsonFormatAndToExcel(userList);
    //     },
    //     (err) => {
    //       console.error(err);
    //       this.showProgressDialog = false;
    //     }
    //   );
    // },
    // async getAllPages(totalPage, list) {
    //   for (let i = 1; i <= totalPage; i++) {
    //     let data = {
    //       page: i,
    //       size: this.size,
    //       ...this.filter
    //     };
    //     await this.httpGet(this.$root.getUserList, data).then((res) => {
    //       list.push(...res.list);
    //       this.progress = Math.floor((i / totalPage) * 100);
    //       console.log('page' + i, list.length);
    //     });
    //     // console.log(5555, list);
    //   }
    // },
    // jsonFormatAndToExcel(list) {
    //   let formatList = [];
    //   list.forEach((item) => {
    //     let obj = {
    //       客户ID: item.uid,
    //       客户昵称: item.nickname,
    //       电话: item.phone,
    //       身份: this.roleMap[item.role],
    //       注册时间: item.created,
    //       余额: item.balance,
    //       // 当前已释放华值: 1,
    //       // 当前冻结华值: 1,
    //       // 当前华券: 1,
    //       // 我的好友人数: item.friend,
    //       // 我的团队人数: item.head
    //     };
    //     formatList.push(obj);
    //   });
    //   myUtils.json2excel(formatList);
    // }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
.struct-select .el-cascader-panel li[aria-haspopup] .el-checkbox{
    display: none !important;
}
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';
>>>.el-form-item__label{
  padding: 0;
  height: 30px;
}
>>>.el-cascader-panel{
    background: red
}
.el-form-item{
  margin: 0;
}
.page-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 24px;
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      background: white;
      box-sizing: border-box;
      padding: 24px 32px;
      border-radius: 10px;
    }
    .filter-box{
      .filter-item {
        margin-right: 28px;
        .select, .input {
          width: 180px;
        }

        .date-input {
          width: 380px;
        }
      }

      .btn-box {
        margin: 0;
      }
    }
    .content {

      // 按钮
      .btn {
        width: 100px;
        height: 32px;
        line-height: 32px;
        confirm-btn();
        font-size: 14px;
        margin: 16px 0;
      }

      .import-btn{
        background: #E67E4E;
        color: #fff;
        border-color: #E67E4E;
        padding: 0 12px;
        width: auto;
        margin: 0;
        margin-left: 12px;
      }

      // // 表格按钮
      // .table-btn {
      //   // width: 65px;
      //   height: 24px;
      //   line-height: 24px;
      //   color: gray3;
      //   font-size: 12px;
      //   margin-right: 8px;
      //   cancel-btn();
      //   padding: 0 8px;
      // }

      .table {
        margin-top: 16px !important;
      }
    }
  }

  .dialog-content {
    flex-y();
  }

  .dialog-title{
    // height: 56px;
    // background: #FAFAFA;
  }

  .user-form{
    flex-x(space-between);
    padding: 0 12px 20px;
    flex-wrap: wrap;
  }

  .form {
    width: 100%;
    flex-center();
    margin: 8px 0;
  }
  .wx-box{
    flex-y();
    padding-top: 12px;
    padding-bottom: 45px;
    img{
      width: 185px;
      height: 185px;
    }
    div{
      word(16, #333);
      margin-top: 24px;
      text-align: center;
    }
  }
  .group-list{
    padding: 15px 0 30px;
    .checkbox{
      width: 33.33%;
      margin-right: 0;
      padding-left: 20px;
      box-sizing: border-box;
    }
  }
}
</style>
